enum ConversationReminderMessageType {
  Static = "static",
  Dynamic = "dynamic",
}

type ConversationReminder = {
  enabled: boolean;
  delayInMinutes: number;
  messageType: ConversationReminderMessageType;
  staticMessage: string;
  dynamicPrompt: string;
};

type ConversationReminderStatic = ConversationReminder & {
  messageType: ConversationReminderMessageType.Static;
};

type ConversationReminderDynamic = ConversationReminder & {
  messageType: ConversationReminderMessageType.Dynamic;
};

export {
  ConversationReminderMessageType,
  ConversationReminderStatic,
  ConversationReminderDynamic,
  ConversationReminder,
};
